import { render, staticRenderFns } from "./TempChartKD2.vue?vue&type=template&id=06c1a3c8&scoped=true"
import script from "./TempChartKD2.vue?vue&type=script&lang=js"
export * from "./TempChartKD2.vue?vue&type=script&lang=js"
import style0 from "./TempChartKD2.vue?vue&type=style&index=0&id=06c1a3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1a3c8",
  null
  
)

export default component.exports